import React from 'react';
import Svg from '../../images/ilustrations/Anye_pote2_new.svg';

const AnyePote2 = () => (
    <img src={Svg} alt="Pote" style={{ width: '2.5em', height: '2.5em' }} />
);

export default AnyePote2;
